import { Chip, Tooltip } from '@mui/material'
import mapping from 'atoms/Icon/mapping'
import { useGetPartnership } from 'pages/Partnership/api'
import { useEffect, useState } from 'react'

export interface PartnershipTagProps {
  parntershipId?: number
}

interface PartnershipTagState {
  partyName: string | undefined
  counterPartyName: string | undefined
}

export default function PartnershipTag(props: PartnershipTagProps) {
  const [state, setState] = useState<PartnershipTagState>({
    partyName: undefined,
    counterPartyName: undefined,
  })

  const { data, refetch, isLoading } = useGetPartnership(
    {
      id: props.parntershipId as any,
    },
    {
      enabled: Boolean(props.parntershipId),
    }
  )

  const handleOpenPartnership = () => {
    window.open(`/partnership/${props.parntershipId}`, '_blank')
  }

  useEffect(() => {
    if (!data) {
      return
    }

    setState({
      partyName: String(data.party?.name).toUpperCase().slice(0, 20),
      counterPartyName: String(data.counterparty?.name).toUpperCase().slice(0, 20),
    })
  }, [data])

  useEffect(() => {
    // TODO: Disabled since party and counterparty names are not being shown in the PartnershipTag
    // refetch()
  }, [props.parntershipId])

  if (!data || !props.parntershipId) {
    return null
  }

  return (
    <Tooltip title={`Partnership`}>
      <Chip
        size="medium"
        onClick={(e: any) => {
          e.preventDefault()
          handleOpenPartnership()
        }}
        label={mapping['Partnership']}
      />
    </Tooltip>
  )
}
